
export enum SaleMethodBranchItemEnum {
  ItemCategory = 1,
}
